import { Stack, Autocomplete, TextField } from "@mui/material";
import ActionButton from "components/react-lib/generic-ui/ActionButton";
import Loader from "components/react-lib/generic-ui/Loader";
import React, { useState } from "react";
import { useSelector } from "react-redux";

export default function FileSelector({
  selectCallback = ({ fileId, fileData }) => {},
}) {
  const filesState = useSelector((state) => state.collections.files);
  const [file, setFile] = useState(null);
  const [attaching, setAttaching] = useState(false);

  if (!filesState || filesState.loading) {
    return <Loader message="Loading files" />;
  }

  // Sort files from most recent to oldest
  const sortedFiles = [...filesState.documents].sort((a, b) => {
    const aTime = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const bTime = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    return bTime - aTime;
  });

  const options = sortedFiles.map((file) => ({
    ...file,
    label: `(${file.type}) ${file.name || file.filename}`,
  }));

  const handleSelect = () => {
    if (!file) return;
    selectCallback({
      fileId: file.id,
      fileData: file,
    });
  };

  return (
    <Stack spacing={1}>
      <Autocomplete
        options={options}
        getOptionLabel={(option) => option.label}
        value={file}
        onChange={(event, newValue) => setFile(newValue)}
        renderInput={(params) => <TextField {...params} label="Select file" />}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        clearOnEscape
      />

      <ActionButton
        data-testid="finalize-attach-button"
        variant="contained"
        color="primary"
        disabled={!file}
        onClick={handleSelect}
        processing={attaching}
      >
        Use Selected File
      </ActionButton>
    </Stack>
  );
}
